<template>
    <vs-row>
        <vs-col v-for="(card, index) of dataCard" :key="index" vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
            <Card :card="excludeKey(listKeyForExclude, card)"/>
        </vs-col>
    </vs-row>
</template>

<script>
import Card from './Card'
import {exclude} from '@/utils/mixins'
export default {
    props: ['dataCard'],
    mixins: [exclude],
    data(){
        return {
            listKeyForExclude: ['team_id']
        }
    },
    components: {
        Card
    }
}
</script>